<!--
    描述：清单检查 --- vxe-table 版本
    时间：2021-10-25
    Created by 王帅
-->
<template>
    <div class="h100">
        <vxe-table :loading="loading" border highlight-hover-row highlight-current-row ref="xTable" auto-resize resizable align="center" height="auto" size="small" show-footer :footer-method="getSummaries" :sort-config="{ trigger: 'cell' }" :row-class-name="rowClassName" :cell-class-name="cellClassName" @header-cell-click="onHeaderClick" @sort-change="sortChange" @current-change="rowClick">
            <vxe-column type="seq" width="70" title="序号" sortable></vxe-column>
            <vxe-column field="sname" title="单位工程名称" sortable show-overflow width="160"></vxe-column>
            <vxe-column field="code" title="清单编码" sortable show-overflow width="150">
                <template #header>
                    <el-cascader v-model.native.stop="filterObj.codeArr" :options="filterObj.codeList" :collapse-tags="true" class="header-cascader" :props="{ expandTrigger: 'hover', label: 'text', multiple: true }">
                    </el-cascader>
                    <span>清单编码</span>
                </template>
            </vxe-column>
            <!-- 列 1 -->
            <vxe-colgroup field="type1">
                <!-- 自定义合并头部 -->
                <template #header>
                    <el-select v-model="priceType1" size="small">
                        <el-option v-for="(item, index) in priceTypeList" :key="'价格类别1' + index" :label="item.name" :value="item.value"></el-option>
                    </el-select>
                </template>
                <!-- 合并列 -->
                <vxe-column v-for="(item, index) in listData.filterArr" :key="'筛选列' + index" :title="item.label" :field="item.key" :visible="item.visible" :width="item.width" :min-width="item.minWidth" :align="item.align" :header-align="item.headerAlign" :sortable="item.sortable" :show-overflow="item.showOverFlow" :filters="[{ data: '' }]" :filter-method="item.filterMethods">
                    <!-- 如果需要渲染的 -->
                    <template #default="{ row }" v-if="item.needRender">
                        <span>{{ item.render(row) }}</span>
                    </template>
                    <!-- 如果需要筛选的 -->
                    <template #filter="{ $panel, column }">
                        <el-select multiple filterable ref="filterSelect" collapse-tags popper-class="drop-poper" :popper-append-to-body="false" v-model="option.data" v-for="(option, inx) in column.filters" :key="item.key + inx" @change="$panel.changeOption($event, !!option.data, option)">
                            <el-option v-for="(m, n) in listData[item.key]" :key="n" :label="m.text" :value="m.value"></el-option>
                        </el-select>
                        <!-- <vxe-select
                            multiple
                            v-model="option.data"
                            v-for="(option, inx) in column.filters"
                            :key="item.key + inx"
                            @change="$panel.changeOption($event, !!option.data, option)"
                        >
                            <vxe-option
                                v-for="(m, n) in filterObj.nameList"
                                :key="n"
                                :label="m.text"
                                :value="m.value"
                            ></vxe-option>
                        </vxe-select>
                        <input type="type" v-for="(option, index) in column.filters" :key="index" v-model="option.data" @input="$panel.changeOption($event, !!option.data, option)"> -->
                    </template>
                </vxe-column>
                <vxe-column v-for="(item, index) in listData.normalArr" :key="'左侧类别' + index" :title="item.label" :field="item.key" :visible="item.visible" :width="item.width" :min-width="item.minWidth" :align="item.align" :header-align="item.headerAlign" :sortable="item.sortable" :show-overflow="item.showOverFlow">
                    <!-- 如果需要渲染的 -->
                    <template #default="{ row }">
                        <span :class="{ 'color-red': row.isRed }">
                            {{ item.needRender ? item.render(row) : row[item.key] }}
                        </span>
                    </template>
                </vxe-column>
            </vxe-colgroup>
            <!-- 说明 -->
            <vxe-column v-for="(item, index) in remarkCloumn" :key="'说明' + index" :title="item.label" :field="item.key" :visible="item.visible" :width="item.width" :align="item.align" :header-align="item.headerAlign">
                <template #default="{ row }">
                    <span v-if="row.hasRemark ===1" class="blue-text cursor-pointer" @click="editRemark(row)">编辑</span>
                    <span v-else class="gray-text cursor-pointer" @click="editRemark(row)">编辑</span>
                </template>
            </vxe-column>
        </vxe-table>
        <!-- 列过滤/联合排序 弹窗 -->
        <el-dialog :title="dialogObj.title" :visible.sync="dialogObj.visible" :width="dialogObj.width" :close-on-click-modal="false" @closed="handleClose">
            <!-- 列过滤 -->
            <div class="text-center h100 overflow-hidden" v-if="dialogObj.visible && dialogObj.type === 'filter'">
                <!-- 对比列筛选 -->
                <el-row class="check-row mb20">
                    <el-col :span="4" class="check-name text-overflow">
                        <el-tooltip :content="getPhaseObj.name1">
                            <span>{{ getPhaseObj.name1 }}</span>
                        </el-tooltip>
                        <el-checkbox class="ml10" @change="handleAllChange($event, 'compareArr1')" v-model="checkAll.compare1">全选</el-checkbox>
                    </el-col>
                    <el-col :span="20" class="check-content">
                        <el-checkbox v-for="(item, index) in compareArr1" :label="item.key" :key="'对比列1' + index" v-model="item.visible">{{ item.label }}</el-checkbox>
                    </el-col>
                </el-row>
                <!-- 说明 -->
                <el-row class="check-row">
                    <el-col :span="4" class="check-name text-overflow">说明
                        <el-checkbox class="ml10" @change="handleAllChange($event, 'remarkCloumn')" v-model="checkAll.remark">全选
                        </el-checkbox>
                    </el-col>
                    <el-col :span="20" class="check-content">
                        <el-checkbox v-for="(item, index) in remarkCloumn" :label="item.key" :key="'对比列3' + index" v-model="item.visible">{{ item.label }}
                        </el-checkbox>
                    </el-col>
                </el-row>
                <!-- 确认取消按钮 -->
                <div slot="footer" class="dialog-footer text-center">
                    <el-button @click="dialogObj.visible = false" size="small">取 消
                    </el-button>
                    <el-button type="primary" size="small" :loading="btnLoading" @click="doFilter">确 定
                    </el-button>
                </div>
            </div>

            <!-- 联合排序 -->
            <div class="text-center h100 overflow-hidden" v-if="dialogObj.visible && dialogObj.type === 'sort'">
                <el-row class="check-row mb10">
                    <el-col :span="4" class="check-name text-overflow">
                        <el-tooltip :content="getPhaseObj.name1">
                            <span>{{ getPhaseObj.name1 }}</span>
                        </el-tooltip>
                        <el-checkbox class="ml10" @change="handleAllChange($event, 'sortArr')" v-model="checkAll.sortAll">全选</el-checkbox>
                    </el-col>
                    <el-col :span="20" class="check-content">
                        <el-checkbox v-for="(item, index) in sortArr" :label="item.key" :key="'排序' + index" v-model="item.visible">{{ item.label }}</el-checkbox>
                    </el-col>
                </el-row>
                <el-row class="mb20 info-text">
                    <i class="el-icon-warning"></i> 帮助说明：
                    <p>根据联合排序的条件选项，分析、对比所选择的一个或多个单位工程中相同的清单项综合单价是否不一致，条件可单选或多选。</p>
                    <p>清单编码：筛选清单编码前九位数字一致的清单项。清单编码默认编码中前九位数字，有字母的清单编码，取编码后面数字中的前九位数。</p>
                    <p>清单名称：筛选清单名称一致的清单项</p>
                    <p>清单特征；筛选清单特征一致的清单项</p>
                    <p>计量单位：筛选计量单位一致的清单项</p>
                </el-row>

                <!-- 确认取消按钮 -->
                <div slot="footer" class="dialog-footer text-center">
                    <el-button @click="dialogObj.visible = false" size="small">取 消
                    </el-button>
                    <el-button type="primary" size="small" :loading="btnLoading" @click="doSort">确 定
                    </el-button>
                </div>
            </div>

            <!-- 添加备注说明 -->
            <div class="h100 notice-container" v-if="dialogObj.visible && dialogObj.type === 'remark'">
                <div class="notice-form-header">
                    <el-row :gutter="20">
                        <el-col :span="12">单位工程名称： <i class="bold-text">{{ currentRow.sname }}</i></el-col>
                        <el-col :span="12">清单编码： <i class="bold-text">{{ currentRow.code }}</i></el-col>
                        <el-col :span="12">清单名称： <i class="bold-text">{{ currentRow.projectName }}</i></el-col>
                        <el-col :span="12">计量单位： <i class="bold-text">{{ currentRow.unit }}</i></el-col>
                        <el-col :span="24">清单特征： <i class="bold-text">{{ currentRow.projectFeatures }}</i></el-col>
                        <el-col :span="12">工程量： <i class="bold-text">{{ `${currentRow.quantity}&nbsp;&nbsp;${currentRow.unit}` }}</i></el-col>
                        <el-col :span="12">单价： <i class="bold-text">{{ currentRow.rateCost }}</i></el-col>
                        <el-col :span="12">合价： <i class="bold-text">{{ currentRow.addup }}</i></el-col>
                    </el-row>
                </div>
                <template v-if="remarkList.length > 0">
                    <p class="sub-title mt10">其它备注： </p>
                    <div class="content-wrap" >
                        <div class="notice-box" v-for="(item, index) in remarkList" :key="'remark' + index">
                            <p>
                                <i class="el-icon-user-solid"></i>
                                <span class="ml10">{{ item.userName }}</span>
                                <span class="ml10">{{ item.createDate }}</span>
                            </p>
                            <p>{{ item.remark }}</p>
                        </div>
                    </div>
                </template>

                <!-- 底部评论区域 -->
                <div slot="footer" class="notice-footer">
                    <el-input type="textarea" v-model="currentRow.newRemark" @input="$forceUpdate()" placeholder="请输入修正异常项原因..." :autosize="{minRows: 2}" maxlength="200" show-word-limit></el-input>
                    <div class="text-center mt20">
                        <el-button @click="dialogObj.visible = false" size="small">取 消
                        </el-button>
                        <el-button type="primary" size="small" :loading="btnLoading" @click="doPublish">发 布
                        </el-button>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
// js
import { selectConditionArray } from "@/api/modules/analysisDetail";
import { getListInfo } from "@/api/modules/analysisInventory";
import {getRemarks, saveRemarks } from "@/api/modules/analysisDetail";
export default {
    name: "",
    data() {
        return {
            allTableData: [], // 固定的原始数据
            priceTypeList: [],
            priceType1: "1007002", // 默认控制价
            loading: false,
            curColumn: "", // 当前点击的列 property
            // 全选
            checkAll: {
                compare1: false,
                remark: true,
                sortAll: true,
            },
            // 对比价格1 列
            compareArr1: [
                {
                    label: "清单名称",
                    key: "projectName",
                    visible: true,
                    width: "200",
                    minWidth: "200",
                    align: "left",
                    headerAlign: "center",
                    sortable: true,
                    showOverFlow: true,
                    needFilter: true,
                    filterMethods: ({ option, row }) => {
                        return option.data.includes(row.projectName);
                    },
                },
                {
                    label: "清单特征",
                    key: "projectFeatures",
                    visible: true,
                    width: "auto",
                    minWidth: "300",
                    align: "left",
                    headerAlign: "center",
                    sortable: true,
                    showOverFlow: true,
                    needFilter: false,
                },
                {
                    label: "计量单位",
                    key: "unit",
                    visible: true,
                    width: "110",
                    minWidth: "0",
                    align: "left",
                    headerAlign: "center",
                    sortable: false,
                    showOverFlow: true,
                    needFilter: true,
                    filterMethods: ({ option, row }) => {
                        return option.data.includes(row.unit);
                    },
                },
                {
                    label: "工程量",
                    key: "quantity",
                    visible: true,
                    width: "100",
                    minWidth: "0",
                    align: "right",
                    headerAlign: "center",
                    sortable: true,
                    showOverFlow: true,
                    needRender: true,
                    render: (row) => {
                        return this.NumberToFixed(row.quantity, 3);
                    },
                },
                {
                    label: "单价",
                    key: "rateCost",
                    visible: true,
                    width: "100",
                    minWidth: "0",
                    align: "right",
                    headerAlign: "center",
                    sortable: true,
                    showOverFlow: true,
                    needRender: true,
                    needFilter: false,
                    render: (row) => {
                        return this.NumberToFixed(row.rateCost, 2);
                    },
                },
                {
                    label: "合价",
                    key: "addup",
                    visible: true,
                    width: "120",
                    minWidth: "0",
                    align: "right",
                    headerAlign: "center",
                    sortable: true,
                    showOverFlow: true,
                    needRender: true,
                    needFilter: false,
                    render: (row) => {
                        return this.NumberToFixed(row.addup, 2);
                    },
                },
            ],
            // 排序 arr
            sortArr: [
                {
                    label: "清单编码",
                    key: "code",
                    prop: 'code',
                    visible: true,
                },
                {
                    label: "清单名称",
                    key: "project_name",
                    prop: 'projectName',
                    visible: true,
                },
                {
                    label: "清单特征",
                    key: "project_features",
                    prop: 'projectFeatures',
                    visible: true,
                },
                {
                    label: "计量单位",
                    key: "unit",
                    prop: 'unit',
                    visible: true,
                }
            ],
            // 说明
            remarkCloumn: [
                {
                    label: "说明",
                    key: "remark",
                    visible: true,
                    width: "100",
                    align: "center",
                    headerAlign: "center",
                    sortable: true,
                }
            ],
            // 暂存的 当前参数
            queryParams: {},
            btnLoading: false,
            dialogObj: {
                title: "列过滤",
                visible: false,
                width: "1000px",
                type: "filter",
                exportExcel: false,
            },

            totalSum: 0, // 合价合计
            filterObj: {
                codeArr: [], // 当前绑定的编码数组
                codeList: [], // 全部编码数组
                // 清单名称过滤数组
                nameList: [],
                // 计量单位数组
                unitList: [],
            },
            timer: null,
            status: true,
            colorFlag: "0",
            // 备注说明
            currentRow: {
                newRemark: ''
            }, // 当前行对象
            remarkList: []
        };
    },
    created() {
        // 获取期数含价格的类型数组
        this.getPriceList();
    },
    methods: {
        // 初始获取期数
        getPriceList() {
            this.priceTypeList = [];
            selectConditionArray({
                    id: this.curProjectId,
                })
                .then((res) => {
                    this.priceTypeList = res.data;
                })
                .catch((err) => {});
        },

        // 滚动加载
        loadData() {
            let $table = this.$refs.xTable;

            // 如果没选单位工程
            if (this.queryParams?.treeIds?.length === 0) {
                this.loading = true;
                $table ? $table.loadData([]) : "";
                setTimeout(() => {
                    this.loading = false;
                }, 1000)
                return;
            }

            this.getTableData().then((data) => {
                if ($table) {
                    $table.loadData(data);
                }
            });
        },

        // 初始获得数据
        getTableData() {
            let that = this;
            this.loading = true;
            let query = this.$utils.clone(this.queryParams, true);

            return new Promise((resolve) => {
                getListInfo(query)
                    .then((res) => {
                        this.loading = false;
                        this.colorFlag = res.data.colorFlag;

                        // 变量代替
                        let allRecords = res.data.records

                        // 获取要排序的字段
                        let arr = this.sortArr.filter(x => x.visible).map(x => x.prop)

                        allRecords.map((item, index) => {
                            if (index > 0) {
                                // 判断
                                let status = false
                                arr.some(y => {
                                    if (y === 'code') {
                                        let _prev = allRecords[index - 1][y].replace(/[a-zA-Z]*/g, '')
                                        let _next = item[y].replace(/[a-zA-Z]*/g, '')
                                        status = _prev.slice(0, 9) !== _next.slice(0, 9)
                                        // console.log(status)
                                    } else {
                                        status = item[y] !== allRecords[index - 1][y]
                                    }

                                    // console.error(item[y])
                                    // console.error(allRecords[index - 1][y])
                                    // console.error(status)

                                    if (status) return status
                                })

                                item.isStripe = status ? !allRecords[index - 1].isStripe : allRecords[index - 1].isStripe
                                // item.isRed = this.colorFlag === '1' && (allRecords[index - 1].isStripe === item.isStripe) && (allRecords[index - 1].rateCost !== item.rateCost)
                            } else {
                                item.isStripe = true
                                item.isRed = false
                            }
                        })

                        // 保存全部数据
                        this.allTableData = allRecords;

                        // 颜色对比
                        let _sliceArr = this.arraySlice()
                        _sliceArr.map((arr, index) => {
                            let _defaultRate = arr[0].rateCost
                            arr.map(x => {
                                x.isRed = this.colorFlag === '1' && (x.rateCost !== _defaultRate)
                            })
                        })

                        resolve(allRecords);
                    })
                    .catch((err) => {
                        this.loading = false;
                    });
            });
        },

        // 行单击事件
        rowClick({ newValue, oldValue, row, rowIndex }) {
            this.$emit("rowClick", row);
        },

        // 表尾合计行
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];

            columns.forEach((column, index) => {
                sums[index] = null;

                if (index === 0) {
                    sums[index] = "合计";
                    return;
                }

                // 工程量
                if (column.property === "quantity") {
                    let values = data.map((x) => parseFloat(x.quantity));

                    if (!values.every((value) => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                        sums[index] = sums[index].toFixed(3);
                    }
                }

                // 第一个 合价
                if (column.property === "addup") {
                    let values = data.map((x) => parseFloat(x.addup));

                    if (!values.every((value) => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                        sums[index] = sums[index].toFixed(2) + " 元";
                    }
                }
            });
            this.totalSum = sums[sums.length - 1];
            return [sums];
        },

        // 排序变化事件
        sortChange({ column, property, order }) {
            this.colorFlag = "0";

            // if (property === 'sname') {
            //     this.colorFlag = '1'
            // } else {
            //     this.colorFlag = '0'
            // }
        },

        // 清除排序
        clearSort() {
            this.$refs.xTable.clearSort();
        },

        // 清除所有列过滤
        clearFilter() {
            this.$refs.xTable.clearFilter();
        },

        // 延时
        doDelay() {
            // 如果此时定时器在， 清除
            if (this.timer) {
                clearTimeout(this.timer);
            }

            // 没继续点击后 做操作处理
            this.timer = setTimeout(() => {
                this.status = true;
                if (this.status) {
                    this.loadData();
                }
            }, 1200);
        },

        // 行样式
        rowClassName({ row, rowIndex }) {
            if (this.colorFlag === "0") {
                return "";
            }

            if (row.isStripe) {
                return "stripe-row";
            }
        },

        // 列样式
        cellClassName({ row, rowIndex, $rowIndex, column, columnIndex, $columnIndex }) {
            // 剩下单独的
            if (this.curColumn === column.property) {
                return "active-cell";
            }

            return "";
        },

        // 表头点击事件
        onHeaderClick({ $rowIndex, column }) {
            this.curColumn = column.property;
        },

        // 打开列过滤弹窗
        openFilter() {
            this.dialogObj.title = "列过滤";
            this.dialogObj.type = "filter";
            this.dialogObj.visible = true;
        },

        // 确认过滤
        doFilter() {
            this.$refs.xTable.refreshColumn();

            this.handleClose();
        },

        // 列过滤全选事件
        handleAllChange(status, type) {
            this[type].map((x) => {
                x.visible = status;
            });
        },

        // 打开排序弹窗
        openSort() {
            this.dialogObj.title = "联合排序";
            this.dialogObj.type = "sort";
            this.dialogObj.visible = true;
        },

        // 确认排序
        doSort() {
            let _sort = this.sortArr.filter(x => x.visible)
            this.queryParams.sortField = _sort.map(x => x.key) || []
            this.queryParams.unitQuery = this.queryParams.sortField.length ===0 ? '0': '1'
            this.loadData();
            this.handleClose();
        },

        // 弹窗关闭
        handleClose() {
            this.dialogObj.visible = false;
            this.btnLoading = false;
        },

        // toFixed
        NumberToFixed(prop, digit) {
            let num = digit === 2 ? "0.00" : "0.000";
            return prop ? prop.toFixed(digit) : num;
        },

        // 点击编辑备注说明
        editRemark(row) {
            this.currentRow = this.$utils.clone(row, true);
            this.currentRow.newRemark = '';
            this.dialogObj.title = "备注说明";
            this.dialogObj.type = "remark";
            this.dialogObj.visible = true;
            this.getRemarkList()
        },

        // 获取备注列表
        getRemarkList() {
            let params = {
                projectId: this.curProjectId,
                treeId: this.currentRow.treeId,
                billId1: this.currentRow.id,
                type: '1',
                code: this.currentRow.code
            }
            getRemarks(params)
                .then(res => {
                    this.remarkList = res.data
                })
                .catch(err => {})
        },

        // 确认发布 备注
        doPublish() {
            let params = {
                projectId: this.curProjectId,
                treeId: this.currentRow.treeId,
                billId1: this.currentRow.id,
                type: '1',
                code: this.currentRow.code,
                remark: this.currentRow.newRemark
            }
            saveRemarks(params)
                .then(res => {
                    this.handleClose()
                    this.loadData();
                })
                .catch(err => {})
        },

        // 获取表格数据
        getListData() {
            return this.$refs.xTable.getTableData().visibleData || []
        },

        // 清除全部条件
        clearAll() {
            this.$refs.xTable.clearAll();
        },

        // 拆分数组
        // 根据stripe 拆分此时的数组
        arraySlice() {
            let resultArr = [], count = 1
            for (let i = 1; i < this.allTableData.length; i++) {
                // 如果是最后一条了
                if (i === this.allTableData.length - 1) {
                    resultArr.push(this.allTableData.slice(i-count, i))
                }

                // 从 第 1个（第二条数据）开始 比较
                if (this.allTableData[i].isStripe !== this.allTableData[i - 1].isStripe) {
                    resultArr.push(this.allTableData.slice(i-count, i))
                    count = 1
                } else {
                    count ++
                }
            }
            return resultArr
        },

        // 切换 全部数据/异常数据
        changeData(showAll) {
            this.loading = true;
            let _sliceArr = this.arraySlice()
            let _errorList = []

            // 遍历切割好的数组  找到 存在isRed 异常项的
            _sliceArr.map(x => {
                let _exist = x.find(y => y.isRed)
                if (_exist) {
                    _errorList.push(...x)
                }
            })

            if (showAll) {
                this.$refs.xTable.loadData(this.allTableData);
                setTimeout(() => {
                    this.loading = false;
                }, 500);
            } else {
                this.$refs.xTable.loadData(_errorList);
                setTimeout(() => {
                    this.loading = false;
                }, 500);
            }
        },
    },
    computed: {
        // 项目ID
        curProjectId() {
            return this.$route.query.projectId;
        },

        // 获取选中的 phase的Type
        getPhaseObj() {
            let _item1 = this.priceTypeList.find((x) => x.value === this.priceType1);

            let _name1 = _item1 ? _item1.name : "";

            return {
                type1: _item1 ? _item1.type : 1,
                name1: _name1,
            };
        },

        // 需要过滤的数据(材料名称， 单位)
        listData() {
            let _filter = this.compareArr1.filter((x) => x.needFilter);
            let _noFilter = this.compareArr1.filter((x) => !x.needFilter);
            return {
                filterArr: _filter,
                normalArr: _noFilter,
                projectName: this.filterObj.nameList,
                unit: this.filterObj.unitList,
            };
        },
    },
    watch: {
        // 监听复选框变化
        sortArr: {
            handler: function(arr) {
                let _false = arr.find(x => x.visible === false)
                this.checkAll.sortAll = !_false
            },
            deep: true
        },

        compareArr1: {
            handler: function(arr) {
                let _false = arr.find(x => x.visible === false)
                this.checkAll.compare1 = !_false
            },
            deep: true
        },
        // 备注
        remarkCloumn: {
            handler: function(arr) {
                let _false = arr.find(x => x.visible === false)
                this.checkAll.remark = !_false
            },
            deep: true
        },

        // 监听两个下拉选的变化
        priceType1(val) {
            this.queryParams.phase = val;
            this.queryParams.type = this.getPhaseObj.type1;

            this.loadData();
        },
        // 清单编码发生变化时的函数处理
        "filterObj.codeArr": {
            handler: function(arr) {
                this.status = false
                this.queryParams.code = arr.map(x => x[x.length - 1])

                this.doDelay()
            },
            deep: true,
        },
    },
};
</script>
<style scoped lang="less">
.check-row {
    margin-bottom: 7px;
    background-color: #a3e3ff;
    height: 35px;
    line-height: 35px;
    font-weight: 700;
    color: #333;

    .check-name {
        border-right: 1px solid #1d7f8a;
        text-align: right;
        // padding-right: 15px;
        padding: 0 68px 0 10px;
        position: relative;
        text-align: center;

        label {
            position: absolute;
            right: 10px
        }
    }

    .check-content {
        text-align: left;
        padding-left: 15px;
    }
}

.header-cascader {
    width: 30px;
    margin-right: 10px;
    overflow: hidden;
    vertical-align: middle;
    height: 25px;
    border-radius: 5px;

    /deep/ .el-input__suffix {
        right: 3px;
    }

    /deep/ .el-input__suffix-inner {
        margin-top: -15px;
        display: inline-block;
        vertical-align: middle;

        .el-input__icon {
            margin-left: 7px;
        }
    }

    /deep/ .el-cascader__tags {
        visibility: hidden;
    }
}

.blue-text {
    color: #2671cc;
}

.gray-text {
    color: rgba(71, 68, 72, 0.4);
}

.info-text {
    padding: 10px;
    background-color: #dbf4ff;
    text-align: left;
}
</style>